(() => {
  const pop = document.getElementById('kf-pdp-email');
  if (!pop || window.kfPdpEmailInitialized) return;
  window.kfPdpEmailInitialized = true;
  const preview = new URLSearchParams(location.search).get('kf_email_preview') === '1';
  const store = {get(k) {try {return localStorage.getItem(k);} catch {return null;}},set(k,v) {try {localStorage.setItem(k,v);} catch {}}};
  const doneKey = 'kfadv_popup_done', seenKey = 'kf_pdp_email_seen';
  const seen = Number(store.get(seenKey) || 0);
  if (!preview && (store.get(doneKey) || Date.now()-seen < 15*86400000)) return;
  let chosen = '', priorFocus, priorOverflow, open = false;
  const form = pop.querySelector('[data-pop-form]'), email = form.querySelector('input[type=email]');
  const cta = pop.querySelector('[data-pop-claim]'), err = pop.querySelector('[data-pop-err]');
  function showView(name) {
    pop.querySelectorAll('[data-view]').forEach(el => el.classList.toggle('is-active',el.dataset.view === name));
    if (name === 'claim') email.focus();
    if (name === 'sms') { const sms = pop.querySelector('[data-kf-sms-form]'); sms.elements.email.value = email.value.trim(); sms.elements.phone.focus(); }
    if (name === 'done') pop.querySelector('[data-done-heading]').focus();
  }
  function close() {
    pop.classList.remove('is-open');pop.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow=priorOverflow;open=false;
    priorFocus?.focus?.();
  }
  function show() {
    if (document.hidden) return;
    if ([...document.querySelectorAll('dialog[open], [aria-modal="true"]:not(#kf-pdp-email):not([aria-hidden="true"])')].some(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && getComputedStyle(el).opacity !== '0')) return;
    priorFocus=document.activeElement;priorOverflow=document.documentElement.style.overflow;
    pop.classList.add('is-open');pop.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow='hidden';open=true;
    if (!preview) store.set(seenKey,String(Date.now()));
    pop.querySelector('[data-pop-close]').focus();
    if (preview && new URLSearchParams(location.search).get('kf_sms_preview') === '1') showView('sms');
  }
  pop.querySelectorAll('[data-pop-close]').forEach(el=>el.addEventListener('click',close));
  pop.querySelectorAll('[data-pop-option]').forEach(el=>el.addEventListener('click',()=>{
    chosen=el.dataset.popOption;pop.querySelector('[data-pop-chosen]').textContent=chosen;showView('claim');
  }));
  pop.querySelector('[data-pop-back]').addEventListener('click',()=>{showView('offer');pop.querySelector('[data-pop-option]').focus();});
  document.addEventListener('keydown',e=>{
    if (!open) return;
    if (e.key==='Escape') {e.preventDefault();close();return;}
    if(e.key==='Tab') {
      const els=[...pop.querySelectorAll('button,a,input,[tabindex="0"]')].filter(el=>!el.disabled&&el.getClientRects().length);
      const first=els[0],last=els.at(-1);
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    }
  });
  email.addEventListener('input',()=>cta.classList.toggle('is-ready',email.validity.valid&&email.value.length>0));
  async function applyDiscount() {
    const root = window.Shopify?.routes?.root || '/';
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 8000);
    try {
      const currentResponse = await fetch(root + 'cart.js', {credentials:'same-origin', signal:controller.signal});
      if (!currentResponse.ok) return;
      const current = await currentResponse.json();
      const codes = [...new Set([...(current.discount_codes || []).map(item => item.code), 'KINDER15'])];
      const response = await fetch(root + 'cart/update.js', {
        method:'POST', credentials:'same-origin', signal:controller.signal,
        headers:{'Content-Type':'application/json'}, body:JSON.stringify({discount:codes.join(',')})
      });
      if (!response.ok) return;
      const cart = await response.json();
      document.dispatchEvent(new CustomEvent('kf:discount-updated', {detail:cart}));
      const discount = (cart.discount_codes || []).find(item => item.code.toUpperCase() === 'KINDER15');
      if (discount && (discount.applicable || cart.item_count === 0)) {
        const message = pop.querySelector('[data-pop-discount-status]');
        if (message) message.textContent = message.dataset.applied;
      }
    } catch { /* Signup succeeded; keep the manual code visible if discount application fails. */ }
    finally { clearTimeout(timer); }
  }
  let finished = false;
  async function finishOffer() { if (finished) return; finished = true; showView('done'); await applyDiscount(); }
  pop.querySelector('[data-sms-skip]').addEventListener('click', finishOffer);
  document.addEventListener('kf:sms-signup-requested', event => { if (event.detail?.placement === 'popup') finishOffer(); });
  form.addEventListener('submit',async e=>{
    e.preventDefault();if(cta.disabled||!form.reportValidity())return;
    cta.disabled=true;err.style.display='none';const label=cta.textContent;cta.textContent=cta.dataset.loading;
    const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),20000);
    try {
      const response=await fetch('https://engine.arkpartners.ai/api/klaviyo/subscribe',{
        method:'POST',headers:{'Content-Type':'application/json'},signal:controller.signal,
        body:JSON.stringify({workspace:'kinder-farms',email:email.value.trim(),source:'kinderfarms-pdp-popup',offer:'15-off-kinder15',lp:location.pathname,game_type:chosen})
      });
      const result=await response.json();
      if(!response.ok||result.ok!==true||result.captured!==true)throw new Error('Capture failed');
      store.set(doneKey,'1');showView('sms');
    } catch {err.style.display='block';}
    finally {clearTimeout(timer);cta.disabled=false;cta.textContent=label;}
  });
  setTimeout(show,preview?100:8000);
})();
